import { useContext } from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTheme } from "@mui/material/styles";
import { LayoutContext } from "../../context/LayoutContext";
import useAuth from "../../hooks/useAuth";

export default function SidebarLogout({ overlay }) {
  const theme = useTheme();
  const { collapsed } = useContext(LayoutContext);
  const { logout } = useAuth();

  return (
    <ListItemButton
      onClick={logout}
      sx={{
        mx: 1,
        mb: 1,
        mt: 12,
        borderRadius: 2,
        py: 1.4,
        alignItems: "center",
        gap: collapsed && !overlay ? 0 : 2,
        flexDirection: collapsed && !overlay ? "column" : "row",
        color: "#fff",
        bgcolor: "rgba(255,255,255,0.05)",
        "&:hover": { bgcolor: theme.palette.error.main },
      }}
    >
      <ListItemIcon
        sx={{
          color: "#fff",
          minWidth: 0,
          display: "flex",
          justifyContent: "center",
          mr: collapsed && !overlay ? 0 : 2,
          mb: collapsed && !overlay ? 0.5 : 0,
        }}
      >
        <LogoutIcon />
      </ListItemIcon>

      <ListItemText
        primary="Logout"
        sx={{
          "& .MuiListItemText-primary": {
            fontSize: collapsed && !overlay ? "10px" : "16px",
            fontWeight: 600,
            textAlign: collapsed && !overlay ? "center" : "left",
            lineHeight: 1.2,
          },
        }}
      />
    </ListItemButton>
  );
}
